export const CREDIT_ACTIVITY_STATE_TOKEN = 'CREDIT_ACTIVITY';